import { createSelector } from "reselect";
import getUserAccount from "./get_user_account";

const getUserEmail = createSelector([
  getUserAccount
], (account) => account?.email || null)

export default getUserEmail;
